export const getToken = () => JSON.parse(localStorage.getItem("user"))?.token;

export const setToken = (token) => {
  const userJsonEncoded = localStorage.getItem("user");
  const userObject = userJsonEncoded ? JSON.parse(userJsonEncoded) : {};
  if (!userObject) {
    throw new Error("Could not fetch the user object.");
  }
  localStorage.setItem("user", JSON.stringify({ ...userObject, token }));
};
